import React from "react";
import { Skeleton } from "@mui/material"

export const TableSkeleton = () => {
    return (
        <>
            <Skeleton height={60} />
            <Skeleton height={60} />
            <Skeleton height={60} />
            <Skeleton height={60} />
            <Skeleton height={60} />
            <Skeleton height={60} />
        </>
    );
};
